import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack']),
    ...mapActions(['getSessions']),
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year);
    },
    toggleSession(sval) {
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
      } else {
        this.favorites.sessions.push(sval.id);
        sval.presentations.map(presentation => {
          this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== presentation.id);
        });
      }
      localStorage.setItem('favorites_sessions', JSON.stringify(this.favorites.sessions));
      localStorage.setItem('favorites_presentations', JSON.stringify(this.favorites.presentations));
    },
    togglePresentation(sval, ckey) {
      const id = sval.presentations[ckey].id;
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
        const presentations = sval.presentations.reduce((carry, presentation) => { 
          if (presentation.id !== id && !this.favorites.presentations.includes(id)) carry.push(presentation.id);
          return carry; 
        }, []);
        this.favorites.presentations = this.favorites.presentations.concat(presentations);
      } else if (this.favorites.presentations.find(fav => fav === id)) {
        this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== id);
      } else {
        if (sval.presentations.every(presentation => this.favorites.presentations.concat([id]).includes(presentation.id))) {
          sval.presentations.map(presentation => {
            this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== presentation.id);
          });
          if (!this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions.push(sval.id);
          }
        } else {
          if (this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
          }
          this.favorites.presentations.push(id);
        }
      }
      localStorage.setItem('favorites_sessions', JSON.stringify(this.favorites.sessions));
      localStorage.setItem('favorites_presentations', JSON.stringify(this.favorites.presentations));
    }
  }
})

export default mixins